import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { Link } from "@/components/common/Link";
function formatDate(dateString?: string): string {
  if (!dateString) return "";
  try {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}.${month}.${day}`;
  } catch {
    return "";
  }
}
function stripHtml(html?: string): string {
  if (!html) return "";
  return html.replace(/<[^>]*>/g, "").replace(/\s+/g, " ").trim();
}
function IntelligenceConsumer() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <div className="grid grid-cols-1 gap-12 md:grid-cols-3 md:gap-6">
        {[0, 1, 2].map(i => <div key={i} data-index={i} className="border-t border-border pt-8">
            <div className="h-3 w-24 bg-muted animate-pulse mb-6" />
            <div className="h-6 w-full bg-muted animate-pulse mb-3" />
            <div className="h-6 w-3/4 bg-muted animate-pulse mb-4" />
            <div className="h-4 w-full bg-muted animate-pulse mb-2" />
            <div className="h-4 w-5/6 bg-muted animate-pulse mb-8" />
            <div className="h-4 w-20 bg-muted animate-pulse" />
          </div>)}
      </div>;
  }
  if (error) {
    return <p className="text-sm font-default text-muted-foreground">
        Unable to load stories at this time.
      </p>;
  }
  if (!posts || posts.length === 0) {
    return <p className="text-sm font-default text-muted-foreground">
        No stories to display yet.
      </p>;
  }
  return <div className="grid grid-cols-1 gap-12 md:grid-cols-3 md:gap-6">
      {posts.slice(0, 3).map((post, i) => {
      const excerpt = stripHtml(post.excerpt || post.content || "");
      return <article data-index={i} key={post.id} className="group border-t border-border pt-8 transition-colors duration-300 hover:border-primary">
            <time className="block font-mono text-[0.8125rem] tracking-normal text-muted-foreground" dateTime={post.date}>
              {formatDate(post.date)}
            </time>
            <h3 className="mt-6 font-default text-xl font-medium leading-tight tracking-tight text-foreground line-clamp-3 transition-transform duration-300 group-hover:translate-x-1">
              {post.title}
            </h3>
            {excerpt && <p className="mt-4 font-default text-base leading-relaxed text-muted-foreground line-clamp-2">
                {excerpt}
              </p>}
            <Link to={post.link || "#"} className="mt-8 inline-block font-default text-sm text-foreground underline decoration-border decoration-1 underline-offset-4 transition-colors duration-200 hover:decoration-primary hover:text-primary">
              {"Read more →"}
            </Link>
          </article>;
    })}
    </div>;
}
export default function Stories() {
  const wp_query_params = {
    post_type: "post",
    per_page: 3,
    order: "desc",
    orderby: "date"
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section data-section-id="10697" id="all-stories" className="bg-background text-foreground py-24 md:py-32">
      <div className="mx-auto max-w-[1440px] px-6 md:px-12">
        <div className="grid grid-cols-1 gap-6 md:grid-cols-12 md:items-end">
          <h2 className="font-default font-medium tracking-tight text-foreground leading-[1.02] text-[clamp(2rem,3.8vw,3.25rem)] md:col-span-6">
            Latest Stories
          </h2>
          <div className="md:col-span-6 md:col-start-7 md:flex md:justify-end">
            <Link to="/NewsroomPage" className="font-default text-sm text-foreground underline decoration-border decoration-1 underline-offset-4 transition-colors duration-200 hover:decoration-primary hover:text-primary">
              {"View all stories →"}
            </Link>
          </div>
        </div>

        <div className="mt-10 h-px w-full bg-border" />

        <div className="mt-16">
          <PostsProvider wp_query={{
          post_type: "post",
          per_page: 3,
          order: "desc",
          orderby: "date"
        }}>
            <IntelligenceConsumer />
          </PostsProvider>
        </div>
      </div>
    </section>;
}